export default "__VITE_ASSET__CpUyrdxL__"